import { render, staticRenderFns } from "./policy-detail.vue?vue&type=template&id=c7628240&scoped=true&"
import script from "./policy-detail.vue?vue&type=script&lang=js&"
export * from "./policy-detail.vue?vue&type=script&lang=js&"
import style0 from "./policy-detail.vue?vue&type=style&index=0&id=c7628240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7628240",
  null
  
)

export default component.exports